(function() {
  let interstitialOverlay = {
    show: function() {
      document.getElementById('interstitialOverlay').classList.add('show');
    },
    hide: function() {
      document.getElementById('interstitialOverlay').classList.remove('show');
    },
    initAndShow: function(iframeSrc, title) {
      document.getElementById('interstitialIframe').src = iframeSrc;
      document.getElementById('interstitialHeader').textContent = title;
      this.show();
    },
    unload: function() {
      document.getElementById('interstitialIframe').src = '';
      document.getElementById('interstitialHeader').textContent = '';
      this.hide();
    },
    bindEvents: function() {
      document.querySelectorAll('.trigger-interstitial-overlay').forEach(button => {
        button.addEventListener('click', function() {
          interstitialOverlay.initAndShow(this.dataset.iframeSrc, this.dataset.title);
        });
      });
      document.querySelectorAll('.interstitial-close').forEach(button => {
        button.addEventListener('click', function() {
          interstitialOverlay.unload();
        });
      });
    }
  };
  interstitialOverlay.bindEvents();
})();
